import { Card } from "components/common";
import styled from "styled-components";

export const StyledGroupManagementContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.5rem 1rem 0 1rem;
  flex-grow: 1;
`;

export const StyledHeadline = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 1rem;
  box-sizing: border-box;
  height: 50px;
`;
export const StyledButtonArea = styled.div`
  display: flex;
  justify-content: end;
  column-gap: 1rem;
`;

export const StyledGroupListWrapper = styled.div`
  min-height: 200px;
  flex-grow: 1;
`;

export const StyledCard = styled(Card)`
  height: calc(100% - 40px);
  width: 100%;
`;
